/**
 * アプリ内戻るボタンのフラグ管理
 *
 * navigate(-1) では state を渡せないため、
 * グローバルなフラグで「アプリ内戻るボタンが押された」ことを記録する
 */

// グローバルなフラグ（モジュールスコープ）
let isAppBackFlag = false;
let resetTimeoutId: NodeJS.Timeout | null = null;

export function useAppBackFlag() {
  /**
   * アプリ内戻るボタンが押されたことをマーク
   */
  const markAppBack = () => {
    isAppBackFlag = true;

    // 既存のタイムアウトをクリア
    if (resetTimeoutId) {
      clearTimeout(resetTimeoutId);
    }

    // 500ms後に自動リセット（念のため）
    resetTimeoutId = setTimeout(() => {
      isAppBackFlag = false;
      resetTimeoutId = null;
    }, 500);
  };

  /**
   * 現在アプリ内戻るボタンによる遷移かチェック
   */
  const isAppBack = () => {
    return isAppBackFlag;
  };

  /**
   * フラグをリセット
   */
  const reset = () => {
    isAppBackFlag = false;
    if (resetTimeoutId) {
      clearTimeout(resetTimeoutId);
      resetTimeoutId = null;
    }
  };

  return {
    markAppBack,
    isAppBack,
    reset,
  };
}
